module.exports = __webpack_public_path__ + "static/media/Logo-icon-credit_no_border.a242a702.png";